import { useEffect, useState } from 'react'

const API = import.meta.env.VITE_API_URL ?? 'http://localhost:3001'

interface Mission {
  id: string; title: string; status: string; amount: number
  date: string; city: string; type: string; createdAt: string
  company: { id: string; name: string; email: string }
  _count: { assignments: number }
}

const STATUS_LABELS: Record<string, string> = {
  OPEN: 'Ouverte', ASSIGNED: 'Assignée', IN_PROGRESS: 'En cours',
  COMPLETED: 'Terminée', CANCELLED: 'Annulée',
}
const STATUS_COLORS: Record<string, string> = {
  OPEN: 'bg-accent/10 border-accent/25 text-accent',
  ASSIGNED: 'bg-warning/10 border-warning/25 text-warning',
  IN_PROGRESS: 'bg-success/10 border-success/25 text-success',
  COMPLETED: 'bg-white/[0.08] border-white/[0.15] text-text-secondary',
  CANCELLED: 'bg-danger/10 border-danger/25 text-danger',
}

export default function AdminMissionsPage() {
  const [missions, setMissions] = useState<Mission[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${API}/api/admin/missions?limit=50`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('velink_token')}` },
    })
      .then((r) => r.json())
      .then((data) => { setMissions(data.items ?? []); setTotal(data.total ?? 0) })
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="text-text-muted animate-pulse">Chargement…</div>

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-text-primary">Missions</h1>
        <p className="text-text-secondary mt-1">{total} missions au total</p>
      </div>

      <div className="glass-card overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/[0.08] text-text-secondary">
              <th className="text-left px-5 py-3 font-medium">Mission</th>
              <th className="text-left px-5 py-3 font-medium">Entreprise</th>
              <th className="text-left px-5 py-3 font-medium">Ville</th>
              <th className="text-center px-5 py-3 font-medium">Montant</th>
              <th className="text-center px-5 py-3 font-medium">Statut</th>
              <th className="text-center px-5 py-3 font-medium">Date</th>
            </tr>
          </thead>
          <tbody>
            {missions.map((m) => (
              <tr key={m.id} className="border-b border-white/[0.04] hover:bg-white/[0.02]">
                <td className="px-5 py-3 text-text-primary font-medium max-w-[200px] truncate">{m.title}</td>
                <td className="px-5 py-3 text-text-secondary">{m.company.name}</td>
                <td className="px-5 py-3 text-text-secondary">{m.city}</td>
                <td className="px-5 py-3 text-center text-success font-medium">{(m.amount / 100).toFixed(0)} €</td>
                <td className="px-5 py-3 text-center">
                  <span className={['text-xs px-2 py-0.5 rounded-full border', STATUS_COLORS[m.status] ?? ''].join(' ')}>
                    {STATUS_LABELS[m.status] ?? m.status}
                  </span>
                </td>
                <td className="px-5 py-3 text-center text-text-muted">
                  {new Date(m.date).toLocaleDateString('fr-FR')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
